export enum LocaleTranslationKeysEnum {
  SwoUserInfoMenuCommon = 'swo/menu-common',
  SwoUserInfoMenuCommonLogout = 'logout',
  SwoUserInfoMenuCommonNavigateHome = 'navigate-home',
  SwoUserInfoMenuCommonUserMenu = 'user-menu',
  SwoUserInfoMenuCommonMyAccount = 'my-account',

  GenericWhitespacesTrimHint = 'genericWhitespacesTrimHint',
  GenericWhitespacesBetweenWordsTrimHint = 'genericWhitespacesBetweenWordsTrimHint',
  GenericWhitespacesBetweenWordsWithNewlinesTrimHint = 'genericWhitespacesBetweenWordsWithNewlinesTrimHint',
  GenericMaxLengthHint = 'genericMaxLengthHint',
  GenericMinLengthHint = 'genericMinLengthHint',

  AssistantButtonTooltipOpenAssistant = 'assistantButtonTooltipOpenAssistant',
  AssistantButtonTooltipHideAssistant = 'assistantButtonTooltipHideAssistant',
  AssistantTitle = 'assistantTitle',
  AssistantSubtitle = 'assistantSubtitle',
  AssistantClearHistory = 'assistantClearHistory',
  AssistantImagePreviewDefaultImageLabel = 'assistantImagePreviewDefaultImageLabel',
  AssistantImagePreviewOpen = 'assistantImagePreviewOpen',
  AssistantImagePreviewDownload = 'assistantImagePreviewDownload',
  AssistantImagePreviewOpenLabel = 'assistantImagePreviewOpenLabel',
  AssistantEmptyResponseMessage = 'assistantEmptyResponseMessage',
  WaffleTooltip = 'waffleTooltip',
  WaffleMenuTitle = 'waffleMenuTitle',
  WaffleScreenReaderOpenHint = 'waffleScreenReaderOpenHint',
  WaffleEmptyTitle = 'waffleEmptyTitle',
  WaffleEmptyDescription = 'waffleEmptyDescription',
  WaffleErrorTitle = 'waffleErrorTitle',
  WaffleErrorDescription = 'waffleErrorDescription',
  WaffleContactAdminLabel = 'waffleContactAdminLabel',
  WaffleRetryLabel = 'waffleRetryLabel',

  SwoUserInfoMenuCommonContactUs = 'swoUserInfoMenuCommonContactUs',
  SwoUserInfoMenuCommonContactUsDescription = 'swoUserInfoMenuCommonContactUsDescription',
  SwoUserInfoMenuUserLanguageSettings = 'swoUserInfoMenuUserLanguageSettings',
  SwoUserInfoMenuUserLanguageSettingsDescription = 'swoUserInfoMenuUserLanguageSettingsDescription',
  SwoUserInfoMenuUserNotificationSettings = 'swoUserInfoMenuUserNotificationSettings',
  SwoUserInfoMenuUserNotificationSettingsDescription = 'swoUserInfoMenuUserNotificationSettingsDescription',
  SwoUserInfoMenuUserProfileSettings = 'swoUserInfoMenuUserProfileSettings',
  SwoUserInfoMenuUserProfileSettingsDescription = 'swoUserInfoMenuUserProfileSettingsDescription',
  SwoUserInfoMenuUserManagement = 'swoUserInfoMenuUserManagement',
  SwoUserInfoMenuUserManagementDescription = 'swoUserInfoMenuUserManagementDescription',
  SwoUserInfoMenuPrivacySettings = 'swoUserInfoMenuPrivacySettings',

  SupportedLanguagesEnglishUKTitle = 'supportedLanguagesEnglishUKTitle',
  SupportedLanguagesFrenchTitle = 'supportedLanguagesFrenchTitle',
  SupportedLanguagesJapaneseTitle = 'supportedLanguagesJapaneseTitle',
  SupportedLanguagesDutchTitle = 'supportedLanguagesDutchTitle',
  SupportedLanguagesItalianTitle = 'supportedLanguagesItalianTitle',
  SupportedLanguagesSpanishTitle = 'supportedLanguagesSpanishTitle',
  SupportedLanguagesPortogueseTitle = 'supportedLanguagesPortogueseTitle',
  SupportedLanguagesGermanTitle = 'supportedLanguagesGermanTitle',
  SupportedLanguagesKoreanTitle = 'supportedLanguagesKoreanTitle',
  SupportedLanguagesChineseTitle = 'supportedLanguagesChineseTitle',

  ActiveReportsEmpty = 'activeReportsEmpty',
  ActiveReportsEmptyTitle = 'activeReportsEmptyTitle',
  ActiveReportsLinkDescription = 'activeReportsLinkDescription',
  ActiveReportsLinkTitle = 'activeReportsLinkTitle',
  ActiveReportInactiveTitle = 'activeReportInactiveTitle',
  ActiveReportInactiveDescription = 'activeReportInactiveDescription',
  ActiveReportInactiveAction = 'activeReportInactiveAction',
  ActiveReportFullscreen = 'activeReportFullscreen',
  ActiveReportAutoSize = 'activeReportAutoSize',

  AvailableReportsNoReportsConfiguredTitle = 'availableReportsNoReportsConfiguredTitle',
  AvailableReportsNoReportsConfiguredDescription = 'availableReportsNoReportsConfiguredDescription',
  AvailableReportsLinkDescription = 'availableReportsLinkDescription',
  AvailableReportsLinkTitle = 'availableReportsLinkTitle',
  AvailableReportsLinkAction = 'availableReportsLinkAction',
  AvailableReportsSubmitSuccess = 'availableReportsSubmitSuccess',
  AvailableReportsSubmitFailure = 'availableReportsSubmitFailure',

  SupportIssueTypeRequest = 'supportIssueTypeRequest',
  SupportIssueTypeBilling = 'supportIssueTypeBilling',
  SupportIssueTypeCase = 'supportIssueTypeCase',
  SupportIssueTypeIncident = 'supportIssueTypeIncident',
  SupportIssueTypeServiceQuality = 'supportIssueTypeServiceQuality',

  SettingsPageLanguageLabel = 'settingsPageLanguageLabel',
  SettingsPageLanguageHint = 'settingsPageLanguageHint',
  SettingsPageLanguagePlaceholder = 'settingsPageLanguagePlaceholder',

  NoAccessTitle = 'noAccessTitle',
  NoAccessDescription = 'noAccessDescription',
  NoAccessButtonLabel = 'noAccessButtonLabel',
  NoAccessButtonPlaceholder = 'noAccessButtonPlaceholder',

  SupportMyTickets = 'supportMyTickets',
  SupportMyCompanyTickets = 'supportMyCompanyTickets',
  MyCases = 'myCases',
  MyCompanyCases = 'myCompanyCases',
  SupportHomeBillingTitle = 'supportHomeBillingTitle',
  SupportHomeBillingDescription = 'supportHomeBillingDescription',
  SupportHomeRequestTitle = 'supportHomeRequestTitle',
  SupportHomeRequestDescription = 'supportHomeRequestDescription',
  SupportHomeCaseTitle = 'supportHomeCaseTitle',
  SupportHomeCaseDescription = 'supportHomeCaseDescription',
  SupportHomeTroubleshootTitle = 'supportHomeTroubleshootTitle',
  SupportHomeTroubleshootDescription = 'supportHomeTroubleshootDescription',
  TicketsTableEmpty = 'ticketsTableEmpty',
  SupportFormFirstStepTitle = 'supportFormFirstStepTitle',
  SupportFormSecondStepTitle = 'supportFormSecondStepTitle',
  SupportFormThirdStepTitle = 'supportFormThirdStepTitle',
  SupportFormLastStepTitle = 'supportFormLastStepTitle',
  SupportFormModalPageLoading = 'supportFormModalPageLoading',
  SupportTicketsFormRequestPageTitle = 'supportTicketsFormRequestPageTitle',
  SupportCasesFormRequestPageTitle = 'supportCasesFormRequestPageTitle',
  SupportFormRequestTypeLabel = 'supportFormRequestTypeLabel',
  SupportTicketsFormRequestTypeFieldLabel = 'supportTicketsFormRequestTypeFieldLabel',
  SupportCasesFormRequestTypeFieldLabel = 'supportCasesFormRequestTypeFieldLabel',
  SupportFormRequestProductLabel = 'supportFormRequestProductLabel',
  SupportFormRequestProductPlaceholder = 'supportFormRequestProductPlaceholder',
  SupportFormRequestServiceLabel = 'supportFormRequestServiceLabel',
  SupportFormRequestServicePlaceholder = 'supportFormRequestServicePlaceholder',
  SupportFormRequestServiceImpactLabel = 'supportFormRequestServiceImpactLabel',
  SupportFormRequestServiceImpactPlaceholder = 'supportFormRequestServiceImpactPlaceholder',
  SupportFormRequestServicePriorityLabel = 'supportFormRequestPriorityLabel',
  SupportFormRequestServicePriorityPlaceholder = 'supportFormRequestPriorityPlaceholder',
  SupportFormRequestServiceCategoryLabel = 'supportFormRequestServiceCategoryLabel',
  SupportFormRequestServiceCategoryPlaceholder = 'supportFormRequestServiceCategoryPlaceholder',
  SupportFormRequestServiceContractLabel = 'supportFormRequestServiceContractLabel',
  SupportFormRequestServiceContractPlaceholder = 'supportFormRequestServiceContractPlaceholder',
  SupportFormRequestServiceEntitlementLabel = 'supportFormRequestServiceEntitlementLabel',
  SupportFormRequestServiceEntitlementPlaceholder = 'supportFormRequestServiceEntitlementPlaceholder',
  SupportFormRequestServiceSubCategoryLabel = 'supportFormRequestServiceSubCategoryLabel',
  SupportFormRequestServiceSubCategoryPlaceholder = 'supportFormRequestServiceSubCategoryPlaceholder',
  SupportFormRequestServiceSubCategoryTaskLabel = 'supportFormRequestServiceSubCategoryTaskLabel',
  SupportFormRequestServiceConfigItemPlaceholder = 'supportFormRequestServiceConfigItemPlaceholder',
  SupportFormRequestServiceConfigItemLabel = 'supportFormRequestServiceConfigItemLabel',
  SupportFormRequestServiceSubCategoryTaskPlaceholder = 'supportFormRequestServiceSubCategoryTaskPlaceholder',
  SupportFormRequestUploadLabel = 'supportFormRequestUploadLabel',
  SupportFormRequestConfigItemLabel = 'supportFormRequestConfigItemLabel',
  SupportFormRequestDescriptionLabel = 'supportFormRequestDescriptionLabel',
  SupportFormRequestDescriptionPlaceholder = 'supportFormRequestDescriptionPlaceholder',
  SupportFormRequestDetailsLabel = 'supportFormRequestDetailsLabel',
  SupportTicketsFormRequestDetailsPlaceholder = 'supportTicketsFormRequestDetailsPlaceholder',
  SupportCasesFormRequestDetailsPlaceholder = 'supportCasesFormRequestDetailsPlaceholder',
  SupportFormSubmitErrorGeneric = 'supportFormSubmitErrorGeneric',
  SupportFormSubmitErrorFormNotValidForSubmit = 'supportFormSubmitErrorFormNotValidForSubmit',
  SupportFormValidationUploadSize = 'supportFormValidationUploadSize',
  SupportFormValidationUploadLowerSize = 'supportFormValidationUploadLowerSize',
  SupportFormValidationUploadSameFileAgainstExisting = 'supportFormValidationUploadSameFileAgainstExisting',
  SupportFormValidationUploadSameFileAgainstRequested = 'supportFormValidationUploadSameFileAgainstRequested',
  SupportFormValidationIssueShortDescription = 'supportFormValidationIssueShortDescription',
  SupportFormSuccessSend = 'supportFormSuccessSend',
  SupportFormCaseSuccessSend = 'supportFormCaseSuccessSend',
  SupportFormCaseSuccessSendDetails = 'supportFormCaseSuccessSendDetails',
  SupportFormErrorSend = 'supportFormErrorSend',

  SupportFormTicketPriorityLabel = 'supportFormTicketPriorityLabel',
  SupportFormTicketDescriptionLabel = 'supportFormTicketDescriptionLabel',
  SupportFormTicketDetailsLabel = 'supportFormTicketDetailsLabel',
  SupportFormTicketReplyLabel = 'supportFormTicketReplyLabel',
  SupportFormTicketUploadLabel = 'supportFormTicketUploadLabel',
  SupportFormTicketBackButtonLabel = 'supportFormTicketBackButtonLabel',
  SupportCaseDetailCardTitle = 'supportCaseDetailCardTitle',
  SupportTicketDetailCardTitle = 'supportTicketDetailCardTitle',
  SupportTicketDetailTicketNumber = 'supportTicketDetailTicketNumber',
  SupportTicketDetailTicketContract = 'supportTicketDetailTicketContract',
  SupportTicketDetailTicketEntitlement = 'supportTicketDetailTicketEntitlement',
  SupportTicketDetailTicketType = 'supportTicketDetailTicketType',
  SupportTicketDetailTicketServiceName = 'supportTicketDetailTicketServiceName',
  SupportTicketDetailTicketCategory = 'supportTicketDetailTicketCategory',
  SupportTicketDetailTicketRaisedBy = 'supportTicketDetailTicketRaisedBy',
  SupportTicketDetailTicketSubCategory = 'supportTicketDetailTicketSubCategory',
  SupportTicketDetailTicketStatus = 'supportTicketDetailTicketStatus',
  SupportTicketDetailTicketOnHoldReason = 'supportTicketDetailTicketOnHoldReason',
  SupportTicketDetailTicketPriority = 'supportTicketDetailTicketPriority',
  SupportTicketDetailTicketPriorityInfoQuestion = 'supportTicketDetailTicketPriorityInfoQuestion',
  SupportTicketDetailTicketPriorityInfoLink = 'supportTicketDetailTicketPriorityInfoLink',
  SupportTicketDetailTicketCreatedAt = 'supportTicketDetailTicketCreatedAt',
  SupportTicketDetailTicketLastUpdateAt = 'supportTicketDetailTicketLastUpdateAt',
  SupportTicketDescriptionCardTitle = 'supportTicketDescriptionCardTitle',
  SupportTicketAttachmentsCardTitle = 'supportTicketAttachmentsCardTitle',
  SupportTicketAttachmentsCardSubTitle = 'supportTicketAttachmentsCardSubTitle',
  SupportTicketEscalationCardTitle = 'supportTicketEscalationCardTitle',
  SupportTicketEscalationCardSubTitle = 'supportTicketEscalationCardSubTitle',
  SupportTicketEscalationTextareaPlaceholder = 'supportTicketEscalationTextareaPlaceholder',
  SupportTicketEscalationIssuesTitle = 'supportTicketEscalationIssuesTitle',
  SupportTicketEscalationIssuesOriginatesTitle = 'supportTicketEscalationIssuesOriginatesTitle',
  SupportTicketEscalationSuccess = 'supportTicketEscalationSuccess',
  SupportTicketEscalationError = 'supportTicketEscalationError',

  CustomReportRequestLinkDescription = 'customReportRequestLinkDescription',
  CustomReportRequestLinkTitle = 'customReportRequestLinkTitle',

  Download = 'download',
  Off = 'off',
  Reset = 'reset',
  Refresh = 'refresh',
  On = 'on',
  All = 'all',
  End = 'end',
  Cancel = 'cancel',
  Columns = 'columns',
  Accept = 'accept',
  Create = 'create',
  Search = 'search',
  Next = 'next',
  Back = 'back',
  Upload = 'upload',
  Submit = 'submit',
  Save = 'save',
  Edit = 'edit',
  Report = 'report',
  NoActiveReportFound = 'noActiveReportFound',
  RequestNewReport = 'requestNewReport',
  Help = 'help',
  Unknown = 'unknown',
  InvalidFileUpload = 'invalidFileUpload',
  GenericRequiredHint = 'genericRequiredHint',
  SelectAll = 'selectAll',
  DeselectAll = 'deselectAll',
  DayOfWeekMonday = 'dayOfWeekMonday',
  DayOfWeekTuesday = 'dayOfWeekTuesday',
  DayOfWeekWednesday = 'dayOfWeekWednesday',
  DayOfWeekThursday = 'dayOfWeekThursday',
  DayOfWeekFriday = 'dayOfWeekFriday',
  DayOfWeekSaturday = 'dayOfWeekSaturday',
  DayOfWeekSunday = 'dayOfWeekSunday',

  OptionalField = 'Optional',

  PreviousRequestsTitle = 'previousRequestsTitle',
  PreviousRequestsServiceRequestTypeGeneral = 'previousRequestsServiceRequestTypeGeneral',
  PreviousRequestsServiceRequestTypeReport = 'previousRequestsServiceRequestTypeReport',
  PreviousRequestsServiceNothingMoreToLoad = 'previousRequestsServiceNothingMoreToLoad',
  PreviousRequestsServiceLoadMore = 'previousRequestsServiceLoadMore',
  PreviousRequestsServiceLoadingMore = 'previousRequestsServiceLoadingMore',
  RequestsCatalogPageTitle = 'requestsCatalogPageTitle',
  RequestsCatalogPageDescription = 'requestsCatalogPageDescription',
  RequestsCatalogAccessStateAvailable = 'requestsCatalogAccessStateAvailable',
  RequestsCatalogAccessStateSetupRequired = 'requestsCatalogAccessStateSetupRequired',
  RequestsAccessRequestModalTitle = 'requestsAccessRequestModalTitle',
  RequestsAccessRequestModalSuccess = 'requestsAccessRequestModalSuccess',
  RequestsAccessRequestModalSuccessDetails = 'requestsAccessRequestModalSuccessDetails',
  RequestsAccessRequestModalIntro = 'requestsAccessRequestModalIntro',
  RequestsAccessRequestModalBenefit = 'requestsAccessRequestModalBenefit',
  RequestsAccessRequestModalFollowUp = 'requestsAccessRequestModalFollowUp',
  RequestsAccessRequestModalCreateCase = 'requestsAccessRequestModalCreateCase',

  ReadmeNotFoundText = 'readmeNotFoundText',
  ReadmeUrlTitle = 'readmeUrlTitle',

  HomePageTitle = 'homePageTitle',
  HomePageOtherToolsCardTitle = 'homePageOtherToolsCardTitle',
  HomePageOtherToolsCardMessage = 'homePageOtherToolsCardMessage',
  HomePagePendingActionsCardTitle = 'homePagePendingActionsCardTitle',

  ServiceModulesQuickListTitle = 'serviceModulesQuickListTitle',
  HeaderLinksButtonTitle = 'headerLinksButtonTitle',
  SubHeaderSettings = 'subHeaderSettings',
  SubHeaderExampleOption = 'subHeaderExampleOption',
  SessionPanelEmulatedUserText = 'sessionPanelEmulatedUserText',
  SessionPanelRemainingTime = 'sessionPanelRemainingTime',
  HeaderQuickLinkMenu = 'headerQuickLinkMenu',
  QuickLinkMenuItem = 'quickLinkMenuItem',
  QuickLinkMenuItemAuditLogs = 'quickLinkMenuItemAuditLogs',
  QuickLinkMenuItemAuditLogsDescription = 'quickLinkMenuItemAuditLogsDescription',
  QuickLinkMenuItemReports = 'quickLinkMenuItemReports',
  QuickLinkMenuItemReportsDescription = 'quickLinkMenuItemReportsDescription',
  QuickLinkMenuItemRequests = 'quickLinkMenuItemRequests',
  QuickLinkMenuItemRequestsDescription = 'quickLinkMenuItemRequestsDescription',
  QuickLinkMenuItemAutomation = 'quickLinkMenuItemAutomation',
  QuickLinkMenuItemAutomationDescription = 'quickLinkMenuItemAutomationDescription',
  QuickLinkMenuItemPublisherUpdates = 'quickLinkMenuItemPublisherUpdates',
  QuickLinkMenuItemPublisherUpdatesDescription = 'quickLinkMenuItemPublisherUpdatesDescription',
  QuickLinkMenuItemServiceManagement = 'quickLinkMenuItemServiceManagement',
  QuickLinkMenuItemServiceManagementDescription = 'quickLinkMenuItemServiceManagementDescription',
  QuickLinkMenuItemCostOptimisation = 'quickLinkMenuItemCostOptimisation',
  QuickLinkMenuItemCostOptimisationDescription = 'quickLinkMenuItemCostOptimisationDescription',
  QuickLinkMenuItemCostAnalytics = 'quickLinkMenuItemCostAnalytics',
  QuickLinkMenuItemCostAnalyticsDescription = 'quickLinkMenuItemCostAnalyticsDescription',
  QuickLinkMenuItemDocumentation = 'quickLinkMenuItemDocumentation',
  QuickLinkMenuItemDocumentationDescription = 'quickLinkMenuItemDocumentationDescription',
  QuickLinkMenuItemMonitoring = 'quickLinkMenuItemMonitoring',
  QuickLinkMenuItemMonitoringDescription = 'quickLinkMenuItemMonitoringDescription',
  QuickLinkMenuItemBackup = 'quickLinkMenuItemBackup',
  QuickLinkMenuItemBackupDescription = 'quickLinkMenuItemBackupDescription',
  QuickLinkMenuItem365Analytics = 'quickLinkMenuItem365Analytics',
  QuickLinkMenuItem365AnalyticsDescription = 'quickLinkMenuItem365AnalyticsDescription',
  QuickLinkMenuItemSecretSharing = 'quickLinkMenuItemSecretSharing',
  QuickLinkMenuItemSecretSharingDescription = 'quickLinkMenuItemSecretSharingDescription',
  QuickLinkMenuItemCloudNavigator = 'quickLinkMenuItemCloudNavigator',
  QuickLinkMenuItemCloudNavigatorDescription = 'quickLinkMenuItemCloudNavigatorDescription',

  SupportCasesTableEmpty = 'casesTableEmpty',
  SupportTableColumnDescription = 'supportTableColumnDescription',
  SupportTableColumnPriority = 'supportTableColumnPriority',
  SupportTableColumnType = 'supportTableColumnType',
  SupportTableColumnCaseId = 'supportTableColumnCaseId',
  SupportTableColumnServiceName = 'supportTableColumnServiceName',
  SupportTableColumnCategory = 'supportTableColumnCategory',
  SupportTableColumnSubCategory = 'supportTableColumnSubCategory',
  SupportTableColumnCreatedAt = 'supportTableColumnCreatedAt',
  SupportTableColumnRaisedBy = 'supportTableColumnRaisedBy',
  SupportTableColumnLastResponseAt = 'supportTableColumnLastResponseAt',
  SupportTableColumnStatus = 'supportTableColumnStatus',
  SupportCreateButtonLabel = 'supportCreateButtonLabel',

  ServiceRequestTypeLabel = 'serviceRequestTypeLabel',
  ServiceRequestBackLabel = 'serviceRequestBackLabel',
  ServiceRequestTypeServiceModule = 'serviceRequestTypeServiceModule',
  ServiceRequestTypeCustom = 'serviceRequestTypeCustom',
  ServiceRequestDescriptionLabel = 'serviceRequestDescriptionLabel',
  ServiceRequestStatusLabel = 'serviceRequestStatusLabel',
  ServiceRequestNumberLabel = 'serviceRequestNumberLabel',
  ServiceRequestServiceModuleNameLabel = 'serviceRequestServiceModuleNameLabel',
  ServiceRequestServiceModuleStatusLabel = 'serviceRequestServiceModuleStatusLabel',
  ServiceRequestAllowedLocationsParameterLabel = 'serviceRequestAllowedLocationsParameterLabel',
  ServiceRequestSubscriptionIdParameterLabel = 'serviceRequestSubscriptionIdParameterLabel',
  ServiceRequestDeploymentStatusLabel = 'serviceRequestDeploymentStatusLabel',

  AuditLogsFilterByTypeLabel = 'auditLogsFilterByTypeLabel',
  AuditLogsTableEmpty = 'auditLogsTableEmpty',
  AuditLogsDetailsParametersEmpty = 'auditLogsDetailsParametersEmpty',
  AuditLogsTableColumnLevel = 'auditLogsTableColumnLevel',
  AuditLogsTableColumnMessage = 'auditLogsTableColumnMessage',
  AuditLogsTableColumnType = 'auditLogsTableColumnType',
  AuditLogsTableColumnDate = 'auditLogsTableColumnDate',
  AuditLogsServiceRequestDetailsTitle = 'auditLogsServiceRequestDetailsTitle',
  AuditLogsServiceRequestDetailsDescription = 'auditLogsServiceRequestDetailsDescription',
  AuditLogsServiceRequestDetailsStatus = 'auditLogsServiceRequestDetailsStatus',
  AuditLogsServiceRequestDetailsScu = 'auditLogsServiceRequestDetailsScu',
  AuditLogsServiceRequestDetailsAppId = 'auditLogsServiceRequestDetailsAppId',
  AuditLogsServiceRequestDetailsServiceModuleId = 'auditLogsServiceRequestDetailsServiceModuleId',

  ProvisioningPageStepperHint = 'provisioningPageStepperHint',
  ProvisioningPageStepperNext = 'provisioningPageStepperNext',
  ProvisioningPageStepperPrevious = 'provisioningPageStepperPrevious',
  ProvisioningGeneralPageParametersTitleLabel = 'provisioningGeneralPageParametersTitleLabel',
  ProvisioningGeneralPageParametersRequestDescriptionLabel = 'provisioningGeneralPageParametersRequestDescriptionLabel',
  ProvisioningGeneralPageParametersSubscriptionLabel = 'provisioningGeneralPageParametersSubscriptionLabel',
  ProvisioningGeneralPageConfirmationTitleSubscriptionChange = 'provisioningGeneralPageConfirmationTitleSubscriptionChange',
  ProvisioningGeneralPageConfirmationMessageSubscriptionChange = 'provisioningGeneralPageConfirmationMessageSubscriptionChange',
  ProvisioningPageModuleParameters = 'provisioningPageModuleParameters',
  ProvisioningParametersGeneralHint = 'provisioningParametersGeneralHint',
  ProvisioningParametersMapStringHint = 'provisioningParametersMapStringHint',
  ProvisioningParametersListStringHint = 'provisioningParametersListStringHint',
  ProvisioningParametersListEnumHint = 'provisioningParametersListEnumHint',
  ProvisioningParametersEnumHint = 'provisioningParametersEnumHint',
  ProvisioningParametersValidationSingleEnumRequired = 'provisioningParametersValidationSingleEnumRequired',
  ProvisioningParametersValidationRequired = 'provisioningParametersValidationRequired',
  ProvisioningParametersValidationMapDuplicates = 'provisioningParametersValidationMapDuplicates',
  ProvisioningParametersValidationListDuplicates = 'provisioningParametersValidationListDuplicates',
  ProvisioningParametersValidationInvalidType = 'provisioningParametersValidationInvalidType',
  ProvisioningDefaultPanelTitle = 'provisioningDefaultPanelTitle',
  ProvisioningDefaultPanelSubTitle = 'provisioningDefaultPanelSubTitle',

  SwoErrorWithUserAccessPermissionsSupport = 'swoErrorWithUserAccessPermissionsSupport',

  SwoErrorWithUserAccessPermissionsGeneralCase = 'swoErrorWithUserAccessPermissionsGeneralCase',
  SwoErrorPagesSharedActionsGoLoginScreen = 'swoErrorPagesSharedActionsGoLoginScreen',
  SwoErrorPagesSharedActionsGoBack = 'swoErrorPagesSharedActionsGoBack',
  SwoErrorPagesSharedActionsGoHome = 'swoErrorPagesSharedActionsGoHome',
  SwoErrorPagesSharedActionsLogout = 'swoErrorPagesSharedActionsLogout',
  SwoErrorPagesSharedFooterText = 'swoErrorPagesSharedFooterText',
  SwoErrorPagesSharedActionsClose = 'swoErrorPagesSharedActionsClose',
  SwoErrorPagesSharedLoggedInAs = 'swoErrorPagesSharedLoggedInAs',
  SwoErrorPagesSharedNavigatedTo = 'swoErrorPagesSharedNavigatedTo',
  SwoErrorPagesSharedOrigin = 'swoErrorPagesSharedOrigin',
  SwoErrorPagesSharedNA = 'swoErrorPagesSharedNA',
  SwoErrorPages401Title = 'swoErrorPages401Title',
  SwoErrorPages401SubTitle = 'swoErrorPages401SubTitle',
  SwoErrorPages401Description = 'swoErrorPages401Description',
  SwoErrorPages403Title = 'swoErrorPages403Title',
  SwoErrorPages403SubTitle = 'swoErrorPages403SubTitle',
  SwoErrorPages403Description = 'swoErrorPages403Description',
  SwoErrorPagesNotRegisteredTitle = 'SwoErrorPagesNotRegisteredTitle',
  SwoErrorPagesNotRegisteredDescription = 'SwoErrorPagesNotRegisteredDescription',
  SwoErrorPages403ImgAlt = 'swoErrorPages403ImgAlt',
  SwoErrorPagesNotRegisteredImgAlt = 'SwoErrorPagesNotRegisteredImgAlt',
  SwoErrorPages404Title = 'swoErrorPages404Title',
  SwoErrorPages404SubTitle = 'swoErrorPages404SubTitle',
  SwoErrorPages404Description = 'swoErrorPages404Description',
  SwoErrorPages404ImgAlt = 'swoErrorPages404ImgAlt',
  SwoErrorPages401ImgAlt = 'swoErrorPages401ImgAlt',
  SwoErrorPages500Title = 'swoErrorPages500Title',
  SwoErrorPages500SubTitle = 'swoErrorPages500SubTitle',
  SwoErrorPages500Description = 'swoErrorPages500Description',
  SwoErrorPages500ImgAlt = 'swoErrorPages500ImgAlt',

  SwoUserPolicySubTitle = 'swoUserPolicySubTitle',
  SwoUserPolicyTitle = 'swoUserPolicyTitle',
  SwoUserPolicyMessage = 'swoUserPolicyMessage',
  SwoUserPolicyErrorMessageDownload = 'swoUserPolicyErrorMessageDownload',
  SwoProductNameTitle = 'swoProductNameTitle',

  PublisherUpdatesTableEmptyGoButton = 'publisherUpdatesTableEmptyGoButton',
  PublisherUpdatesDetailsAskExpertDescription = 'publisherUpdatesDetailsAskExpertDescription',
  PublisherUpdatesDetailsAskExpert = 'publisherUpdatesDetailsAskExpert',
  PublisherUpdatesDetailsAskExpertGuideline = 'publisherUpdatesDetailsAskExpertGuideline',
  PublisherUpdatesDetailsAskExpertCreate = 'publisherUpdatesDetailsAskExpertCreate',
  PublisherUpdatesDetailsAskExpertViewDetails = 'publisherUpdatesDetailsAskExpertViewDetails',
  PublisherUpdatesAskExpertFailureMessage = 'publisherUpdatesAskExpertFailureMessage',
  PublisherUpdatesTableEmptyTitle = 'publisherUpdatesTableEmptyTitle',
  PublisherUpdatesTableEmptySubtext = 'publisherUpdatesTableEmptySubtext',
  PublisherUpdatesTableFilterPublisherLabel = 'publisherUpdatesTableFilterPublisherLabel',
  PublisherUpdatesTableFilterPublisherPlaceholder = 'publisherUpdatesTableFilterPublisherPlaceholder',
  PublisherUpdatesTableFilterUpdateTypeLabel = 'publisherUpdatesTableFilterUpdateTypeLabel',
  PublisherUpdatesTableFilterUpdateTypePlaceholder = 'publisherUpdatesTableFilterUpdateTypePlaceholder',
  PublisherUpdatesTableFilterRegionTemporalLabel = 'publisherUpdatesTableFilterRegionTemporalLabel',
  PublisherUpdatesTableFilterRegionLabel = 'publisherUpdatesTableFilterRegionLabel',
  PublisherUpdatesTableFilterRegionPlaceholder = 'publisherUpdatesTableFilterRegionPlaceholder',
  PublisherUpdatesTableSearchPlaceholder = 'publisherUpdatesTableSearchPlaceholder',
  PublisherUpdatesTableContractualPublishersToggleLabel = 'publisherUpdatesTableContractualPublishersToggleLabel',
  PublisherUpdatesTableContractualPublishersEmpty = 'publisherUpdatesTableContractualPublishersEmpty',
  PublisherUpdatesTableContractualPublishersError = 'publisherUpdatesTableContractualPublishersError',
  PublisherUpdatesTableColumnPublisher = 'publisherUpdatesTableColumnPublisher',
  PublisherUpdatesTableColumnSubject = 'publisherUpdatesTableColumnSubject',
  PublisherUpdatesTableColumnShortImpactSummary = 'publisherUpdatesTableColumnShortImpactSummary',
  PublisherUpdatesTableColumnImpactLevel = 'publisherUpdatesTableColumnImpactLevel',
  PublisherUpdatesTableColumnRelevantCustomerRoles = 'publisherUpdatesTableColumnRelevantCustomerRoles',
  PublisherUpdatesTableColumnType = 'publisherUpdatesTableColumnType',
  PublisherUpdatesTableColumnModifyDate = 'publisherUpdatesTableColumnModifyDate',
  PublisherUpdatesTableColumnCreateDate = 'publisherUpdatesTableColumnCreateDate',
  PublisherUpdatesTableColumnRelevanceStartDate = 'publisherUpdatesTableColumnRelevanceStartDate',
  PublisherUpdatesTableColumnRelevanceEndDate = 'publisherUpdatesTableColumnRelevanceEndDate',
  PublisherUpdatesTableColumnRegion = 'publisherUpdatesTableColumnRegion',
  PublisherUpdatesTableColumnImpactedProduct = 'publisherUpdatesTableColumnImpactedProduct',
  PublisherUpdatesTableColumnImpactedContract = 'publisherUpdatesTableColumnImpactedContract',
  PublisherUpdatesTableColumnImpactedActions = 'publisherUpdatesTableColumnImpactedActions',
  PublisherUpdatesTableColumnActionView = 'publisherUpdatesTableColumnActionView',
  PublisherUpdatesTableColumnPublisherAnnouncementLink = 'publisherUpdatesTableColumnPublisherAnnouncementLink',
  PublisherUpdatesTableColumnPublisherAnnouncementLinkName = 'publisherUpdatesTableColumnPublisherAnnouncementLinkName',
  PublisherUpdatesTableColumnPublisherUpdateDescription = 'publisherUpdatesTableColumnPublisherUpdateDescription',
  PublisherUpdatesTableColumnPublisherUpdateImpact = 'publisherUpdatesTableColumnPublisherUpdateImpact',
  PublisherUpdatesTableColumnPublisherUpdateCallToAction = 'publisherUpdatesTableColumnPublisherUpdateCallToAction',
  PublisherUpdatesBackButtonLabel = 'publisherUpdatesBackButtonLabel',
  PublisherUpdatesSaveFiltersTitle = 'publisherUpdatesSaveFiltersTitle',
  PublisherUpdatesSaveFiltersGuideline = 'publisherUpdatesSaveFiltersGuideline',
  PublisherUpdatesSaveFiltersNameLabel = 'publisherUpdatesSaveFiltersNameLabel',
  PublisherUpdatesSaveFiltersDuplicateError = 'publisherUpdatesSaveFiltersDuplicateError',
  PublisherUpdatesSavedFiltersLabel = 'publisherUpdatesSavedFiltersLabel',
  PublisherUpdatesSavedFiltersPlaceholder = 'publisherUpdatesSavedFiltersPlaceholder',
  PublisherUpdatesSavedFiltersEmpty = 'publisherUpdatesSavedFiltersEmpty',
  PublisherUpdatesSavedFiltersDeleteSuccess = 'publisherUpdatesSavedFiltersDeleteSuccess',

  PublisherContractsTabGeneral = 'publisherContractsTabGeneral',
  PublisherContractsTabMyContracts = 'publisherContractsTabMyContracts',
  PublisherContractsTabFiles = 'publisherContractsTabFiles',
  PublisherContractsTabFilesNoFilesAvailable = 'publisherContractsTabFilesNoFilesAvailable',
  PublisherContractsTableColumnPublisher = 'publisherContractsTableColumnPublisher',
  PublisherContractsTableColumnDescription = 'publisherContractsTableColumnDescription',
  PublisherContractsTableColumnContractNumber = 'publisherContractsTableColumnContractNumber',
  PublisherContractsTableColumnContractCategory = 'publisherContractsTableColumnContractCategory',
  PublisherContractsTableColumnMasterAgreementNumber = 'publisherContractsTableColumnMasterAgreementNumber',
  PublisherContractsTableColumnEnrollmentNumber = 'publisherContractsTableColumnEnrollmentNumber',
  PublisherContractsTableColumnStartDate = 'publisherContractsTableColumnStartDate',
  PublisherContractsTableColumnEndDate = 'publisherContractsTableColumnEndDate',
  PublisherContractsTableColumnCompanyName = 'publisherContractsTableColumnCompanyName',
  PublisherContractsTableColumnActions = 'publisherContractsTableColumnActions',
  PublisherContractsTableEmptyTitle = 'publisherContractsTableEmptyTitle',

  ToasterMessageBadRequestError = 'toasterMessageBadRequestError',
  ToasterMessageUnknownError = 'toasterMessageUnknownError',
  ToasterMessageTimeoutError = 'toasterMessageTimeoutError',

  AuthNoEmailErrorTitle = 'authNoEmailErrorTitle',
  AuthNoEmailErrorSubTitle = 'authNoEmailErrorSubTitle',
  AuthNoEmailErrorHelpText = 'authNoEmailErrorHelpText',

  AuthUnsupportedTenantErrorTitle = 'authUnsupportedTenantErrorTitle',
  AuthUnsupportedTenantErrorSubTitle = 'authUnsupportedTenantErrorSubTitle',
  AuthUnsupportedTenantErrorHelpText = 'authUnsupportedTenantErrorHelpText',
  AuthUnsupportedTenantErrorDescription = 'authUnsupportedTenantErrorDescription',

  AuthVerifyEmailErrorTitle = 'authVerifyEmailErrorTitle',
  AuthVerifyEmailErrorSubTitle = 'authVerifyEmailErrorSubTitle',
  AuthVerifyEmailErrorHelpText = 'authVerifyEmailErrorHelpText',

  AuthUnknownErrorTitle = 'authUnknownErrorTitle',
  AuthUnknownErrorSubTitle = 'authUnknownErrorSubTitle',

  QuickLinkMenuItemMyProjects = 'quickLinkMenuItemMyProjects',
  QuickLinkMenuItemMyProjectsDescription = 'quickLinkMenuItemMyProjectsDescription',
  MyProjectsTableEmptyTitle = 'myProjectsTableEmptyTitle',
  MyProjectsTableSearchPlaceholder = 'myProjectsTableSearchPlaceholder',
  MyProjectsTableColumnStartDate = 'myProjectsTableColumnStartDate',
  MyProjectsTableColumnName = 'myProjectsTableColumnName',
  MyProjectsTableColumnProjectManager = 'myProjectsTableColumnProjectManager',
  MyProjectsTableColumnProjectLink = 'myProjectsTableColumnProjectLink',
  MyProjectsTableColumnDocumentLink = 'myProjectsTableColumnDocumentLink',
  MyProjectsTableColumnRepositoryLink = 'myProjectsTableColumnRepositoryLink',
  MyProjectsTableColumnProjectLinkName = 'myProjectsTableColumnProjectLinkName',
  MyProjectsTableColumnDocumentLinkName = 'myProjectsTableColumnDocumentLinkName',
  MyProjectsTableColumnRepositoryLinkName = 'myProjectsTableColumnRepositoryLinkName',

  NotificationSettingsBackup = 'notificationSettingsBackup',
  NotificationSettingsFormTitle = 'notificationSettingsFormTitle',
  NotificationSettingsFormError = 'notificationSettingsFormError',
  NotificationSettingsFormSuccess = 'notificationSettingsFormSuccess',
  NotificationSettingsFormModeFieldSelectAllPublishersTitle = 'notificationSettingsFormModeFieldSelectAllPublishersTitle',
  NotificationSettingsFormModeFieldSelectAllPublishersDescription = 'notificationSettingsFormModeFieldSelectAllPublishersDescription',
  NotificationSettingsFormModeFieldSelectCustomPublishersTitle = 'notificationSettingsFormModeFieldSelectCustomPublishersTitle',
  NotificationSettingsFormModeFieldSelectCustomPublishersDescription = 'notificationSettingsFormModeFieldSelectCustomPublishersDescription',
  NotificationSettingsFormModeFieldSelectMyContractPublishersTitle = 'notificationSettingsFormModeFieldSelectMyContractPublishersTitle',
  NotificationSettingsFormModeFieldSelectMyContractPublishersDescription = 'notificationSettingsFormModeFieldSelectMyContractPublishersDescription',
  NotificationSettingsPublisherUpdatesMyContractPublishersFieldLabel = 'notificationSettingsPublisherUpdatesMyContractPublishersFieldLabel',
  NotificationSettingsPublisherUpdatesMyContractPublishersEmpty = 'notificationSettingsPublisherUpdatesMyContractPublishersEmpty',
  NotificationSettingsFormDefaultSettingsButtonLabel = 'notificationSettingsFormDefaultSettingsButtonLabel',

  NotificationSettingsFormModeFieldSelectAllUpdateTypesTitle = 'notificationSettingsFormModeFieldSelectAllUpdateTypesTitle',
  NotificationSettingsFormModeFieldSelectAllUpdateTypesDescription = 'notificationSettingsFormModeFieldSelectAllUpdateTypesDescription',
  NotificationSettingsFormModeFieldSelectCustomUpdateTypesTitle = 'notificationSettingsFormModeFieldSelectCustomUpdateTypesTitle',
  NotificationSettingsFormModeFieldSelectCustomUpdateTypesDescription = 'notificationSettingsFormModeFieldSelectCustomUpdateTypesDescription',

  NotificationSettingsPublisherUpdatesUpdateTypesFieldLabel = 'notificationSettingsPublisherUpdatesUpdateTypesFieldLabel',
  NotificationSettingsPublisherUpdatesUpdateTypesFieldPlaceholder = 'notificationSettingsPublisherUpdatesUpdateTypesFieldPlaceholder',

  NotificationSettingsPublisherUpdates = 'notificationSettingsPublisherUpdates',
  NotificationSettingsPublisherUpdatesSubtopicFieldLabel = 'notificationSettingsPublisherUpdatesSubtopicFieldLabel',
  NotificationSettingsPublisherUpdatesSubtopicFieldPlaceholder = 'notificationSettingsPublisherUpdatesSubtopicFieldPlaceholder',

  NotificationSettingsPublisherUpdatesTopicsSummaryTitle = 'notificationSettingsPublisherUpdatesTopicsSummaryTitle',
  NotificationSettingsPublisherUpdatesUpdateTypesSummaryTitle = 'notificationSettingsPublisherUpdatesUpdateTypesSummaryTitle',
  NotificationSettingsPublisherUpdatesScheduleSummaryTitle = 'notificationSettingsPublisherUpdatesScheduleSummaryTitle',
  NotificationSettingsPublisherUpdatesScheduleSummaryFrequencyDayOfMonth = 'notificationSettingsPublisherUpdatesScheduleSummaryFrequencyDayOfMonth',
  NotificationSettingsPublisherUpdatesScheduleSummaryFrequencyImmediate = 'notificationSettingsPublisherUpdatesScheduleSummaryFrequencyImmediate',
  NotificationSettingsPublisherUpdatesScheduleSummaryFrequencyDaily = 'notificationSettingsPublisherUpdatesScheduleSummaryFrequencyDaily',
  NotificationSettingsPublisherUpdatesScheduleSummaryFrequencyDayOfWeek = 'notificationSettingsPublisherUpdatesScheduleSummaryFrequencyDayOfWeek',

  NotificationSettingsPublisherUpdatesTopicFieldLabel = 'notificationSettingsPublisherUpdatesTopicFieldLabel',
  NotificationSettingsPublisherUpdatesTopicFieldPlaceholder = 'notificationSettingsPublisherUpdatesTopicFieldPlaceholder',
  NotificationSettingsPublisherUpdatesSubscriptionDelayWarning = 'notificationSettingsPublisherUpdatesSubscriptionDelayWarning',
  NotificationSettingsReceiveNotifications = 'notificationSettingsReceiveNotifications',
  NotificationSchedulingFormDayOfMonthHint = 'notificationSchedulingFormDayOfMonthHint',
  NotificationSchedulingFormDayOfMonthLabel = 'notificationSchedulingFormDayOfMonthLabel',
  NotificationSchedulingFormDayOfWeekLabel = 'notificationSchedulingFormDayOfWeekLabel',
  NotificationSchedulingFormIntervalOptionDailyDescription = 'notificationSchedulingFormIntervalOptionDailyDescription',
  NotificationSchedulingFormIntervalOptionDailyLabel = 'notificationSchedulingFormIntervalOptionDailyLabel',
  NotificationSchedulingFormIntervalOptionMonthlyDescription = 'notificationSchedulingFormIntervalOptionMonthlyDescription',
  NotificationSchedulingFormIntervalOptionMonthlyLabel = 'notificationSchedulingFormIntervalOptionMonthlyLabel',
  NotificationSchedulingFormIntervalOptionWeeklyDescription = 'notificationSchedulingFormIntervalOptionWeeklyDescription',
  NotificationSchedulingFormIntervalOptionWeeklyLabel = 'notificationSchedulingFormIntervalOptionWeeklyLabel',
  NotificationSchedulingFormScheduleOptionImmediately = 'notificationSchedulingFormScheduleOptionImmediately',
  NotificationSchedulingFormScheduleOptionScheduled = 'notificationSchedulingFormScheduleOptionScheduled',
  NotificationSchedulingFormSubTitle = 'notificationSchedulingFormSubTitle',
  NotificationSchedulingFormTitle = 'notificationSchedulingFormTitle',

  ExportToCsvButtonText = 'exportToCsvButtonText',
  ExportToCsvErrorToastMessage = 'exportToCsvErrorToastMessage',

  CasesGsdcMigrationBannerMessage = 'casesGsdcMigrationBannerMessage',
  CasesGsdcMigrationBannerLink = 'casesGsdcMigrationBannerLink',
  UrlMigrationBannerMessage = 'urlMigrationBannerMessage',

  RequestFormCloseLabel = 'requestFormCloseLabel',
  RequestFormCancelLabel = 'requestFormCancelLabel',
  RequestFormRetryLabel = 'requestFormRetryLabel',
  RequestFormRetryingLabel = 'requestFormRetryingLabel',
  RequestFormDoneLabel = 'requestFormDoneLabel',
  RequestFormKeepEditingLabel = 'requestFormKeepEditingLabel',
  RequestFormDiscardLabel = 'requestFormDiscardLabel',
  RequestFormSubmitLabel = 'requestFormSubmitLabel',
  RequestFormSubmittingLabel = 'requestFormSubmittingLabel',
  RequestFormSubmittedTitle = 'requestFormSubmittedTitle',
  RequestFormSubmittedDescription = 'requestFormSubmittedDescription',
  RequestFormCaseNumberLabel = 'requestFormCaseNumberLabel',
  RequestFormDiscardTitle = 'requestFormDiscardTitle',
  RequestFormDiscardDescription = 'requestFormDiscardDescription',
  RequestFormDiscardMessage = 'requestFormDiscardMessage',
  RequestFormLoadErrorDescription = 'requestFormLoadErrorDescription',
  RequestFormLoadErrorFallbackTitle = 'requestFormLoadErrorFallbackTitle',
  RequestFormLoadErrorUnauthorizedTitle = 'requestFormLoadErrorUnauthorizedTitle',
  RequestFormLoadErrorForbiddenTitle = 'requestFormLoadErrorForbiddenTitle',
  RequestFormLoadErrorNotFoundTitle = 'requestFormLoadErrorNotFoundTitle',
  RequestFormLoadErrorNetworkTitle = 'requestFormLoadErrorNetworkTitle',
  RequestFormLoadErrorServerTitle = 'requestFormLoadErrorServerTitle',
  RequestFormLoadErrorConfigurationTitle = 'requestFormLoadErrorConfigurationTitle',
  RequestFormLoadingSpinner = 'requestFormLoadingSpinner',
  RequestFormLoadingTitle = 'requestFormLoadingTitle',
  RequestFormLoadingDescription = 'requestFormLoadingDescription',
  RequestFormLoadingReassurance = 'requestFormLoadingReassurance',
  RequestFormLoadingDefinitionTitle = 'requestFormLoadingDefinitionTitle',
  RequestFormLoadingOptions = 'requestFormLoadingOptions',
  RequestFormValidationMessage = 'requestFormValidationMessage',
  RequestFormCorrectHighlightedFields = 'requestFormCorrectHighlightedFields',
  RequestFormErrorUnauthorized = 'requestFormErrorUnauthorized',
  RequestFormErrorForbidden = 'requestFormErrorForbidden',
  RequestFormErrorNotFound = 'requestFormErrorNotFound',
  RequestFormErrorNetworkLoad = 'requestFormErrorNetworkLoad',
  RequestFormErrorUnableLoad = 'requestFormErrorUnableLoad',
  RequestFormErrorConfiguration = 'requestFormErrorConfiguration',
  RequestFormErrorNetworkSubmit = 'requestFormErrorNetworkSubmit',
  RequestFormErrorUnableSubmit = 'requestFormErrorUnableSubmit',
  RequestFormErrorDetailsPattern = 'requestFormErrorDetailsPattern',
  RequestFormErrorDetailsSuggestedNames = 'requestFormErrorDetailsSuggestedNames',
  RequestFormServerErrorsValidationTitle = 'requestFormServerErrorsValidationTitle',
  RequestFormServerErrorsValidationTitlePlural = 'requestFormServerErrorsValidationTitlePlural',
  RequestFormServerErrorsSubmissionTitle = 'requestFormServerErrorsSubmissionTitle',
  RequestFormServerErrorsSubmissionTitlePlural = 'requestFormServerErrorsSubmissionTitlePlural',
  RequestFormServerErrorsResolved = 'requestFormServerErrorsResolved',
  RequestFormServerErrorsDismissResolvedAria = 'requestFormServerErrorsDismissResolvedAria',
  RequestFormServerErrorsDismissTitle = 'requestFormServerErrorsDismissTitle',
  RequestFormServerErrorsPreviousAria = 'requestFormServerErrorsPreviousAria',
  RequestFormServerErrorsPreviousTitle = 'requestFormServerErrorsPreviousTitle',
  RequestFormServerErrorsNextAria = 'requestFormServerErrorsNextAria',
  RequestFormServerErrorsNextTitle = 'requestFormServerErrorsNextTitle',
  RequestFormServerErrorsJump = 'requestFormServerErrorsJump',

  SsrmShortDescriptionLabel = 'ssrmShortDescriptionLabel',
  SsrmShortDescriptionPlaceholder = 'ssrmShortDescriptionPlaceholder',
  SsrmShortDescriptionHelp = 'ssrmShortDescriptionHelp',
  SsrmShortDescriptionRequired = 'ssrmShortDescriptionRequired',
  SsrmShortDescriptionMaxLength = 'ssrmShortDescriptionMaxLength',
  SsrmEmailInvalid = 'ssrmEmailInvalid',
  SsrmStringArrayMessage = 'ssrmStringArrayMessage',
  SsrmNoSubscriptions = 'ssrmNoSubscriptions',
  SsrmNoResourceGroups = 'ssrmNoResourceGroups',
  EmulationReadOnly = 'emulationReadOnly',
}
